<template>
  <CustomSelect
    v-model="selectedIntroduce"
    :value="value"
    inputId="HowToIntroducePicker"
    :inputLabel="inputLabel"
    @input="$emit('input', $event)"
    :customOptions="howToIntroduceOptions"
  ></CustomSelect>
</template>

<script>
export default {
  props: {
    defaultSelectedIntroduce: {
      type: [String, Number],
      required: false,
    },
    value: {
      type: [String, Number, null],
      default: null,
    },
    inputLabel: {
      type: [String],
      default: "نحوه آشنایی",
    },
  },
  model: {
    prop: "value",
    event: "input",
  },
  mounted() {
    if (this.defaultSelectedIntroduce) {
      this.selectedIntroduce = this.defaultSelectedIntroduce;
    }
  },
  data() {
    return {
      selectedIntroduce: null,
      howToIntroduceOptions: [
        {
          text: "همه",
          value: null,
        },
        {
          text: "اینستاگرام",
          value: "اینستاگرام",
        },
        {
          text: "معرفی دوستان",
          value: "معرفی دوستان",
        },
        {
          text: "پیج رضا زبان",
          value: "پیج رضا زبان",
        },
        {
          text: "گوگل",
          value: "گوگل",
        },
        {
          text: "تلگرام",
          value: "تلگرام",
        },
        {
          text: "تبلیغات",
          value: "تبلیغات",
        },
      ],
    };
  },
  components: {
    CustomSelect,
  },
};
import CustomSelect from "@/views/components/Utils/CustomSelect.vue";
</script>
